import { MultimediaManagerDialogItem, MultimediaManagerDialogItemTypes } from '../multimedia-manager-dialog/multimedia-manager-dialog-item.model';

export class MultimediaManagerDialogSidenavFolder extends MultimediaManagerDialogItem {

    private editing: boolean;

    constructor(editable?: boolean, fatherFolderInternalId?: string, internalId?: string, name?: string, size?: string, type?: MultimediaManagerDialogItemTypes, url?: string, urlThumbnail?: string, editing?: boolean) {
        super(editable, fatherFolderInternalId, internalId, name, size, type, url, urlThumbnail);
        this.editing = editing;
    }

    public get Editing() {
        return this.editing;
    }
    public set Editing(editing) {
        this.editing = editing;
    }
}
